module.exports = __webpack_public_path__ + "img/dotun.f196da4f.png";